import Router from 'vue-router'

import AppWrapper from '@/components/AppWrapper'

import App from '@/App'
import TermsEs from '@/components/policy/TermsEs'
import TermsSubsEs from '@/components/policy/TermsSubsEs'
import TermsEn from '@/components/policy/TermsEn'
import TermsSubsEn from '@/components/policy/TermsSubsEn'
import TermsSubsPt from '@/components/policy/TermsSubsPt'

import HomeList from '@/components/home/HomeList'
import News from '@/components/news/News'
import Help from '@/components/help/Help'
import Msisdn from '@/components/help/Msisdn'
import Autologin from '@/components/provider/Autologin'
import Waiting from '@/components/Waiting'
import ProviderTyC from '@/components/ProviderTyC'
import Landing from '@/components/Landing/Landing.vue'
import Oyendo from '@/components/Landing/Oyendo.vue'
import Creando from '@/components/Landing/Creando.vue'
import Planes from '@/components/Landing/Planes.vue'
import LandingMK from '@/components/landingMK/LandingMK.vue'
import PaymentsMK from '@/components/paymentsMK/PaymentsMK.vue'

import IntellectualPropEs from '@/components/policy/IntellectualPropEs'
import PrivacyPolicyEs from '@/components/policy/PrivacyPolicyEs'
import PrivacyPolicyEn from '@/components/policy/PrivacyPolicyEn'
import PrivacyPolicyPt from '@/components/policy/PrivacyPolicyPt'

import TracksList from '@/components/tracks/AllTracksList'
import NewTrackWrapper from '@/components/tracks/NewTrackWrapper'
import TrackNew from '@/components/tracks/TrackNew'
import TrackEdit from '@/components/tracks/TrackEdit'

import VinylContest from '@/components/charts/VinylContest'

import Dashboard from '@/components/dashboard/Dashboard'

import UserProfile from '@/components/user/UserProfile'
import MyTracks from '@/components/user/MyTracks'
import MyPlaylists from '@/components/user/MyPlaylists'
import MyFavorites from '@/components/user/MyFavorites'
import MyShopping from '@/components/user/MyShopping'
import MyInfo from '@/components/user/MyInfo'

// import ArtistsList from '@/components/artists/ArtistsList'
import ArtistProfile from '@/components/artistProfile/ArtistProfile'
import ArtistInfo from '@/components/artistProfile/ArtistInfo'
import ArtistTracks from '@/components/artistProfile/ArtistTracks'
import ArtistPlaylists from '@/components/artistProfile/ArtistPlaylists'
import ArtistContact from '@/components/artistProfile/ArtistContact'
import NewArtistsList from '@/components/artists/NewArtistsList'

import NewPlaylistsList from '@/components/playlists/NewPlaylistsList.vue'
import PlaylistProfile from '@/components/PlaylistProfile/PlaylistProfile.vue'
// import PlaylistInfo from '@/components/playlists/PlaylistInfo.vue'
import PlaylistTracks from '@/components/PlaylistProfile/PlaylistTracks.vue'

import Vrtify from '@/components/vrtify/Vrtify.vue'

import NewAlbum from '@/components/tracks/albums/NewAlbum'
import NewDiscover from '@/components/discover/NewDiscover'

import LocalRadios from '@/components/localRadios/RadiosList'

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/provider/waiting/:provider',
      name: 'provider-waiting',
      component: Waiting
    },
    {
      path: '/provider/tyc/:provider',
      name: 'provider-tyc',
      component: ProviderTyC
    },
    {
      path: '',
      name: 'landign',
      component: Landing
    },
    {
      path: '/oyendo',
      name: 'oyendo',
      component: Oyendo
    },
    {
      path: '/creando',
      name: 'creando',
      component: Creando
    },
    {
      path: '/planes',
      name: 'planes',
      component: Planes
    },
    {
      path: '/mk',
      name: 'landingMK',
      component: LandingMK
    },
    {
      path: '/paymentsMk',
      name: 'paymentsMK',
      component: PaymentsMK
    },
    {
      path: '/',
      component: AppWrapper,
      children: [
        {
          path: 'home',
          name: 'home',
          component: HomeList
        },
        {
          path: 'm/:msisdn',
          name: 'msisdn',
          component: Msisdn
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'localContent',
          name: 'local-content',
          component: LocalRadios
        },
        {
          path: 'provider/:provider',
          name: 'provider-autologin',
          component: Autologin
        },
        {
          path: 'playlists',
          name: 'new-playlists-list',
          component: NewPlaylistsList
        },
        {
          path: 'playlist/:id',
          name: 'playlist',
          components: {
            PlaylistProfile
          },
          children: [
            {
              path: 'tracks',
              name: 'playlist-tracks',
              components: {
                'profile-tab': PlaylistTracks
              }
            }
          ]
        },
        {
          path: 'artists',
          name: 'new-artists-list',
          component: NewArtistsList,
          children: [
            {
              path: ':id',
              name: 'artist',
              components: {
                ArtistProfile
              },
              children: [
                {
                  path: 'info',
                  name: 'artist-info',
                  components: {
                    'profile-tab': ArtistInfo
                  }
                },
                {
                  path: 'tracks',
                  name: 'artist-tracks',
                  components: {
                    'profile-tab': ArtistTracks
                  }
                },
                {
                  path: 'playlists',
                  name: 'artist-playlists',
                  components: {
                    'profile-tab': ArtistPlaylists
                  }
                },
                {
                  path: 'contact',
                  name: 'artist-contact',
                  components: {
                    'profile-tab': ArtistContact
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'charts',
          name: 'charts',
          component: VinylContest
        },
        {
          path: 'tracks',
          name: 'new-track-wrapper',
          components: {
            default: NewTrackWrapper
          },
          children: [
            {
              path: 'new-track',
              name: 'track-new',
              component: TrackNew
            },
            {
              path: 'new-album',
              name: 'new-album',
              component: NewAlbum
            }
          ]
        },
        {
          path: 'tracks/edit/:id',
          name: 'track-edit',
          component: TrackEdit
        },
        {
          path: 'discover',
          name: 'discover',
          component: NewDiscover
        },
        {
          path: 'tracksList',
          name: 'tracksList',
          component: TracksList
        },
        {
          path: 'profile',
          name: 'profile',
          components: {
            default: UserProfile
          },
          children: [
            {
              path: 'info',
              name: 'profile-info',
              component: MyInfo
            },
            {
              path: 'my-tracks',
              name: 'my-tracks',
              component: MyTracks
            },
            {
              path: 'my-playlists',
              name: 'my-playlists',
              component: MyPlaylists
            },
            {
              path: 'my-favorites',
              name: 'my-favorites',
              component: MyFavorites
            },
            {
              path: 'my-shopping',
              name: 'my-shopping',
              component: MyShopping
            }
          ]
        },
        // Future implementation of news list section now redirects to the home page
        {
          path: 'news',
          name: 'news-list',
          redirect: '/'
        },
        {
          path: 'news/:id',
          name: 'news',
          component: News
        },
        {
          path: 'help',
          name: 'help',
          component: Help
        },
        {
          path: '360',
          redirect: '/',
          name: '360',
          component: Vrtify
        }
      ]
    },
    {
      path: '/',
      component: App,
      children: [
        {
          path: 'terms/es',
          name: 'terms-es',
          component: TermsEs
        },
        {
          path: 'terms/en',
          name: 'terms-en',
          component: TermsEn
        },
        {
          path: 'general-terms/es',
          name: 'general-terms-es',
          component: TermsSubsEs
        },
        {
          path: 'general-terms/en',
          name: 'general-terms-en',
          component: TermsSubsEn
        },
        {
          path: 'general-terms/pt',
          name: 'general-terms-pt',
          component: TermsSubsPt
        },
        {
          path: 'intellectual-prop/es',
          name: 'intellectual-prop-es',
          component: IntellectualPropEs
        },
        {
          path: 'privacy-policy/es',
          name: 'privacy-policy-es',
          component: PrivacyPolicyEs
        },
        {
          path: 'privacy-policy/en',
          name: 'privacy-policy-en',
          component: PrivacyPolicyEn
        },
        {
          path: 'privacy-policy/pt',
          name: 'privacy-policy-pt',
          component: PrivacyPolicyPt
        }
      ]
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js